import { ChevronRightIcon } from "@heroicons/react/solid";

import { cx } from "utils";


interface PlanTabSwitchArrowProps {
  direction: "left" | "right";
  onClick: () => void;
}

export default function PlanTabSwitchArrow({ direction, onClick }: PlanTabSwitchArrowProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={direction === "right" ? "Switch to Growth plans" : "Switch to Core plans"}
      className={cx(
        "absolute top-1/2 -translate-y-1/2 z-10 border border-gray-200",
        "w-8 h-8 rounded flex items-center justify-center",
        "bg-white shadow-lg",
        "hover:shadow-xl transition-shadow",
        direction === "right" ? "right-2" : "left-2"
      )}
    >
      <ChevronRightIcon
        className={cx("w-4 h-4", direction === "left" && "rotate-180")}
        aria-hidden
      />
    </button>
  );
}
